var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","outlined":""}},[_c('v-card-title',[_vm._v(" BTW boekingen ")]),_c('v-data-table',{attrs:{"disable-sort":"","disable-pagination":"","hide-default-footer":"","items":_vm.vatBookings,"headers":_vm.headers,"dense":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }